import styled from 'styled-components';

import { Loader } from 'shared/components/Loader';
import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';
import { variableFont } from 'styles/theme';
import noop from 'lodash/noop';

interface IBuyButton {
  'data-qa': string;
  onClick?: () => void;
  price: number;
  priceLoading?: boolean;
  title: string;
}

export const BuyButton = ({
  'data-qa': dataQa,
  title,
  price,
  priceLoading,
  onClick = noop,
}: IBuyButton) => (
  <BuyButton.Button data-qa={dataQa} onClick={onClick}>
    <div className="title" data-qa={`${dataQa}-title`}>
      {title}
    </div>
    {priceLoading ? (
      <Loader style={{ width: '24px', marginBottom: '4px' }} />
    ) : (
      <div className="price" data-qa={`${dataQa}-price`}>
        {price ? <LocalizedCurrency price={price} /> : <div className="noPrice" />}
      </div>
    )}
  </BuyButton.Button>
);

BuyButton.Button = styled.button`
  align-items: space-between;
  display: flex;
  flex-direction: column;
  height: 54px;
  justify-content: space-between;
  padding: 8px;
  text-transform: uppercase;
  width: 100%;
  border: ${({ theme }) => theme.borders.black};
  border-radius: ${({ theme }) => theme.borderRadii.button};

  &:active,
  &:focus {
    border: ${({ theme }) => theme.borders.black};
  }

  .title {
    ${variableFont({ size: '9.5px', height: '11px', fontWeight: '400' })};
  }

  .price {
    ${variableFont({ size: '13px', height: '11px', fontWeight: '700' })};
  }

  .noPrice {
    border-top: ${({ theme }) => `1px solid ${theme.colors.black}`};
    width: 24px;
    height: 5px;
  }
`;
